import React, { useEffect, useState, memo } from 'react';
import { AiOutlineRocket } from 'react-icons/ai';
import { FiArrowLeft } from 'react-icons/fi';
import { useHistory } from "react-router-dom";
import { Button, Card, FormGroup, H6, InputGroup, MenuItem } from '@blueprintjs/core';
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import { Select } from "@blueprintjs/select";
import Lottie from 'react-lottie';
import Logo from '../../Assets/Images/SingIn/Logo.png';
import './style'

import { LogomarcaGAVResortsOriginal as LogomarcaGAVResorts, LogomarcaHarmoniaUrbanismoOriginal as LogomarcaHarmoniaUrbanismo, LogomarcaPattroOriginal as LogomarcaPattro, LogomarcaSilvaBrancoOriginal as LogomarcaSilvaBranco, LogomarcaDigitalDevOriginal as LogomarcaDigitalDev } from '../../Assets';
import { SignIn as ContextSignIn } from '../../Context';
import * as LottieFiles from '../../Data/Lottie';
import { CentroDeCusto, Empresa, Logon, Pessoa, SoftwareExterno } from '../../Services/Controllers';
import { NotificacaoInterna } from '../../Services/Notification';
import { CPF } from '../../Themes/TextFormat';
import Email from '../../Themes/TextFormat/Email';
import apiAdonis from '../../Services/adonis';
import './style.css'

import { Container, Form } from './style';
import viewModel from './viewModel';
import { Objeto } from "../../Services/Models";

const View: React.FC<viewModel> = (viewModel) => {
    /* #region  Variáveis  */
    const [getFormularioNome, setFormularioNome] = useState<string>("");
    const [getFormularioEmail, setFormularioEmail] = useState<string>("");
    const [getFormularioCPF, setFormularioCPF] = useState<string>("");
    const [getFormularioSenha, setFormularioSenha] = useState<string>("");
    const [getItemPickerGrupoDeEmpresas, setItemPickerGrupoDeEmpresas] = useState<{ id: number, cd_emp: number, nm_empresa: string, gestor_id: number }>();
    const [getListaPickerGrupoDeEmpresas, setListaPickerGrupoDeEmpresas] = useState<Array<{ id: number, cd_emp: number, nm_empresa: string, gestor_id: number }>>([]);
    const [getCadastrandoUsuario, setCadastrandoUsuario] = useState<boolean>(false);
    const PickerGrupoDeEmpresas = Select.ofType<{ id: number, cd_emp: number, nm_empresa: string, gestor_id: number }>();
    const History = useHistory();
    /* #endregion */

    /* #region  Funções  */
    /* Sobre esta função *//**
     * Valida os dados digitados e tenta efetuar o login do usuário
     **/
    async function EfetuarCadastro(): Promise<void> {
        try {
            if (await ValidarFormulario()) {
                if (await ValidarSenha()) {
                    await setCadastrandoUsuario(true);
                    await apiAdonis.post('usuarios', {
                        username: getFormularioNome,
                        email: getFormularioEmail,
                        password: getFormularioSenha,
                        cd_emp: getItemPickerGrupoDeEmpresas?.cd_emp,
                        send_mail: true
                    }).then(async result => {
                        await setCadastrandoUsuario(false);
                        return result.data.registered ? NotificacaoInterna.ExibirNotificacao("Verificação necessária!", "Um email foi enviado para o administrador aprovar seu acesso.", NotificacaoInterna.TipoDeNotificacao.Sucesso)
                            : NotificacaoInterna.ExibirNotificacao("Usuário já cadastrado!", "O email registrado já possui cadastro.", NotificacaoInterna.TipoDeNotificacao.Erro)
                    })
                }
            }
        }
        catch(e) {
            console.log(e)
        }
    };

    async function ValidarFormulario(): Promise<Boolean> {
        if (!getItemPickerGrupoDeEmpresas) {
            NotificacaoInterna.ExibirNotificacao("Empresa não selecionada", "Informe a empresa ao qual deseja acesso", NotificacaoInterna.TipoDeNotificacao.Erro);
            return false;
        }
        if (!getFormularioNome) {
            NotificacaoInterna.ExibirNotificacao("Nome não preenchido", "Informe o nome", NotificacaoInterna.TipoDeNotificacao.Erro);
            return false;
        }
        if (!getFormularioEmail) {
            NotificacaoInterna.ExibirNotificacao("Email não preenchido", "Informe o email", NotificacaoInterna.TipoDeNotificacao.Erro);
            return false;
        }
        if (!Email.TextoValido(getFormularioEmail)) {
            NotificacaoInterna.ExibirNotificacao("Email inválido", "Digite um email válido", NotificacaoInterna.TipoDeNotificacao.Erro);
            return false;
        }
        if (!getFormularioSenha) {
            NotificacaoInterna.ExibirNotificacao("Senha não preenchida", "Informe a senha", NotificacaoInterna.TipoDeNotificacao.Erro);
            return false;
        }
        return true
    }

    async function ValidarSenha(): Promise<any> {
        var letrasMaiusculas = /[A-Z]/;
        var letrasMinusculas = /[a-z]/;
        var numeros = /[0-9]/;
        var caracteresEspeciais = /[!|@|#|$|%|^|&|*|(|)|-|_]/;

        if (getFormularioSenha.length < 6) {
            NotificacaoInterna.ExibirNotificacao("Senha curta demais.", "Sua senha deve ter no mínimo 6 caracteres.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            return false;
        }

        var auxMaiuscula = 0;
        var auxMinuscula = 0;
        var auxNumero = 0;
        var auxEspecial = 0;

        for (var i = 0; i < getFormularioSenha.length; i++) {
            if (letrasMaiusculas.test(getFormularioSenha[i]))
                auxMaiuscula++;
            else if (letrasMinusculas.test(getFormularioSenha[i]))
                auxMinuscula++;
            else if (numeros.test(getFormularioSenha[i]))
                auxNumero++;
            else if (caracteresEspeciais.test(getFormularioSenha[i]))
                auxEspecial++;
        }

        if (auxMaiuscula > 0) {
            if (auxMinuscula > 0) {
                if (auxNumero > 0) {
                    if (auxEspecial) {
                        return true;
                    }
                }
            }
        }

        if (auxMaiuscula == 0) {
            NotificacaoInterna.ExibirNotificacao("Sua senha não contém letras maiúsculas.", "Por favor, insira pelo menos uma letra maiúscula.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            return;
        }
        if (auxMinuscula == 0) {
            NotificacaoInterna.ExibirNotificacao("Sua senha não contém letras minúsculas.", "Por favor, insira pelo menos uma letra minúscula.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            return;
        }
        if (auxNumero == 0) {
            NotificacaoInterna.ExibirNotificacao("Sua senha não contém números.", "Por favor, insira pelo menos um número.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            return;
        }
        if (auxEspecial == 0) {
            NotificacaoInterna.ExibirNotificacao("Sua senha não contém caracteres especiais.", "Por favor, insira pelo menos um caracter especial.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            return;
        }
    }
    useEffect(() => {
        async function componentDidMount() {
            await apiAdonis.get('/biEmpresas').then(async results => {
                await setListaPickerGrupoDeEmpresas(results.data);
            })
        }
        componentDidMount();
    }, []);
    return (


        <Container>
            <Form>
                <img style={{ marginBottom: "20px" }} src={Logo} />
                <h2 style={{ fontFamily: "StarJedi1" }}>Analytics</h2>
                <h6>Preencha os campos abaixo</h6>
                <FormGroup labelFor="GrupoDeEmpresas" inline={true}>
                    <PickerGrupoDeEmpresas inputProps={{ style: { background: "#ffffff", color: "#00384a" } }} className="selectmenu" popoverProps={{popoverClassName: "bp3-multi-select-popover" }} items={getListaPickerGrupoDeEmpresas} onItemSelect={() => { }} noResults={<MenuItem style={{ width: "276px", background: "#00384a", color: "#ffffff" }} disabled={true} text="Sem resultados disponíveis" />}
                        itemRenderer={(Item: { id: number, cd_emp: number, nm_empresa: string, gestor_id: number }) => <MenuItem style={{ width: "276px", background: "#ffffff", color: "#00384a" }} onClick={async () => {
                            await setItemPickerGrupoDeEmpresas(Item);
                            console.log(Item)
                        }} text={Item.nm_empresa} />} itemPredicate={(Texto: string, Item: { id: number, cd_emp: number, nm_empresa: string, gestor_id: number }) => { return (Item.nm_empresa ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                        <Button style={{ margin: "20px 0px 0px 0px", background: "#00384a", color: "#ffffff", width: "286px", height:"40px", outline: "none", border:"#2F855A 2px solid" }} text={getItemPickerGrupoDeEmpresas?.nm_empresa ?? "Selecione a empresa"} rightIcon="double-caret-vertical" color="#ffffff" />
                    </PickerGrupoDeEmpresas>
                </FormGroup>

                <InputGroup id="Nome" placeholder="Nome" value={getFormularioNome}
                    onChange={async (event: React.FormEvent<HTMLInputElement>) => await setFormularioNome(event.currentTarget.value)}>
                </InputGroup>


                <InputGroup id="Email" placeholder="Email" value={getFormularioEmail}
                    onChange={async (event: React.FormEvent<HTMLInputElement>) => await setFormularioEmail(event.currentTarget.value)}>
                </InputGroup>

                <InputGroup id="Senha" placeholder="Senha" value={getFormularioSenha} type="password"
                    onChange={async (event: React.FormEvent<HTMLInputElement>) => await setFormularioSenha(event.currentTarget.value)}>
                </InputGroup>

                <div>
                    {getCadastrandoUsuario == false && <Button type="submit" id="Submit" intent="primary" onClick={EfetuarCadastro}>Cadastrar</Button>}
                    {getCadastrandoUsuario == true && <div style={{ width: 100, height: 100 }}>
                        <Lottie options={{ animationData: LottieFiles.Load, loop: true, autoplay: true, rendererSettings: { preserveAspectRatio: 'xMidYMid slice' } }} />
                    </div>}
                    <a href="/"><FiArrowLeft />Voltar para tela de Login</a>
                </div>
            </Form>
        </Container>
    );
    /* #endregion */
};

export default View;